<app-entity-mat-dialog-title title="Update Student Department"></app-entity-mat-dialog-title>

<app-error-message [message]=this.errorMessage></app-error-message>

<div style="min-height:200px" *ngIf="showProgressSpinner || isLoading">
    <mat-progress-spinner class="matProgressSpinnerCentered"
        *ngIf="showProgressSpinner || isLoading" mode="indeterminate">
    </mat-progress-spinner>
</div>

<div *ngIf="!isLoading && !showProgressSpinner">
    <form (ngSubmit)="onSubmit(f)" #f="ngForm" class="form">
        <div class="container">
            <div class="row">
                <!-- Current Department Info -->
                <div class="col-12 mb-3">
                    <div class="current-dept-info">
                        <div class="info-row">
                            <span class="info-label">Current Department:</span>
                            <span class="info-value" [ngClass]="{
                                'dept-front': currentDepartmentName === 'Front Dept',
                                'dept-middle': currentDepartmentName === 'Middle Dept',
                                'dept-back': currentDepartmentName === 'Back Dept'
                            }">{{ currentDepartmentName || 'Not Set' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Posted Lessons:</span>
                            <span class="info-value">{{ postedLessonCount }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Back Dept Threshold:</span>
                            <span class="info-value">{{ backDeptThreshold }} lessons</span>
                        </div>
                        <div class="info-row" *ngIf="qualifiesForBackDept && currentDepartmentName !== 'Back Dept'">
                            <span class="qualifies-badge">
                                <mat-icon>info</mat-icon>
                                Student qualifies for Back Department
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Department Selection -->
                <div class="col-12">
                    <mat-form-field class="full-width-field" appearance="outline">
                        <mat-label>Select New Department</mat-label>
                        <mat-select [ngModel]="currentDepartmentId" name="student-department" required>
                            <mat-option
                                *ngFor="let element of this._taxonomyService.student_department"
                                [value]="element.id">
                                {{ element.name }}
                            </mat-option>
                        </mat-select>
                        <mat-hint>Select the department to assign to this student</mat-hint>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </form>
</div>

<mat-dialog-actions align="end" *ngIf="!isLoading">
    <button mat-dialog-close type="button" mat-raised-button color="accent">Cancel</button>
    <button type="button" (click)="onSubmit(f);" mat-raised-button color="primary" [disabled]="showProgressSpinner">
        <span *ngIf="!showProgressSpinner">Save</span>
        <span *ngIf="showProgressSpinner">Saving...</span>
    </button>
</mat-dialog-actions>
